import { render, staticRenderFns } from "./MyBookingsView.vue?vue&type=template&id=240f6d4d&scoped=true"
import script from "./MyBookingsView.vue?vue&type=script&lang=js"
export * from "./MyBookingsView.vue?vue&type=script&lang=js"
import style0 from "./MyBookingsView.vue?vue&type=style&index=0&id=240f6d4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240f6d4d",
  null
  
)

export default component.exports